// Search terms stored on each blog post. Firestore has no full-text search, so
// every word of the title and body is stored along with its prefixes (2+
// chars), and the site queries the array with array-contains.
//
// normalise() and the limits must match searchTerms() in src/app/lib/blog.ts.

const MIN_TERM = 2;
const MAX_TERM = 20;
// Firestore allows 40,000 index entries per document; each token uses two.
const MAX_TOKENS = 15000;

function normalise(text: string): string[] {
  return text
    .toLowerCase()
    .normalize("NFKD")
    .replace(/[̀-ͯ]/g, "")
    // "isn't" -> "isnt"
    .replace(/['’]/g, "")
    .split(/[^a-z0-9]+/)
    .filter((word) => word.length >= MIN_TERM)
    .map((word) => word.slice(0, MAX_TERM));
}

// Drop link and image URLs so they are not indexed.
function readableText(markdown: string): string {
  return markdown
    .replace(/\]\([^)]*\)/g, "] ")
    .replace(/https?:\/\/\S+/g, " ")
    .replace(/<[^>]+>/g, " ");
}

export function buildSearchTokens(title: string, body: string): string[] {
  const tokens = new Set<string>();
  for (const word of normalise(`${title} ${readableText(body)}`)) {
    for (let end = MIN_TERM; end <= word.length; end++) {
      tokens.add(word.slice(0, end));
      if (tokens.size >= MAX_TOKENS) return [...tokens];
    }
  }
  return [...tokens];
}
